/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background colour`)
};

const es_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de fondo`)
};

const de_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundfarbe`)
};

const nl_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achtergrondkleur`)
};

const fr_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de fond`)
};

const it_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore di sfondo`)
};

const pt_br2_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de fundo`)
};

const pt_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de fundo`)
};

const ja_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景色`)
};

const zh_cc_bg = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景颜色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_bg = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_bg(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_bg", locale)
	if (locale === "en") return en_cc_bg(inputs)
	if (locale === "es") return es_cc_bg(inputs)
	if (locale === "de") return de_cc_bg(inputs)
	if (locale === "nl") return nl_cc_bg(inputs)
	if (locale === "fr") return fr_cc_bg(inputs)
	if (locale === "it") return it_cc_bg(inputs)
	if (locale === "pt-BR") return pt_br2_cc_bg(inputs)
	if (locale === "pt") return pt_cc_bg(inputs)
	if (locale === "ja") return ja_cc_bg(inputs)
	return zh_cc_bg(inputs)
};